import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import {
  GetAllAssociatedTransferStations,
  createTransferStationInchargeMaster,
  getAllTransferStationInchargeMaster,
  getAllTransferStationMaster,
  updateTransferStationInchargeMaster,
} from "../../Apis/transferStationApi";
import Select from "react-select";
import ExcelJS from "exceljs";
const TransferStationInchargeMaster = ({ t }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const headers = [
    "InchargeName",
    "associatedTransferStation",
    "emailId",
    "isSupervisor",
    "mobileNumber",
    "status",
    "actions",
  ];
  const [transferStationInchargeData, setTransferStationInchargeData] =
    useState([]);
  const [associatedTransferStationData, setAssociatedTransferStationData] =
    useState([]);
  const [editTransferStationInchargeData, setEditTransferStationInchargeData] =
    useState("");
  const [sortConfig, setSortConfig] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [filterOriginalTSInchargeData, setFilterOriginalTSInchargeData] = useState([]);
  const [formInput, setFormInput] = useState({
    transferStationInchargeName: "",
    associatedTransferStationIds: [],
    emailId: "",
    isSupervisor: true,
    mobileNumber: "",
    isActive: true,
    transferStationInchargeId: "",
  });
  const [editTransferStationInchargeId, setEditTransferStationInchargeId] =
    useState(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedTransferStationIncharge, setSelectedTransferStationIncharge] =
    useState(null);
  const resetRef = useRef(null);
  const [isInputValid, setIsInputValid] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const resetFields = (reset) => {
    setFormInput({
      transferStationInchargeName: "",
      associatedTransferStationIds: "",
      emailId: "",
      isSupervisor: "",
      mobileNumber: "",
      isActive: "",
    });
    resetRef.current();
  };

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedTransferStationIncharge(null);
    setFormSubmitted(false);
  };



  const handleEditTransferStationIncharge = async (
    selectedTransferStationInchargeData
  ) => {
    setEditTransferStationInchargeData(selectedTransferStationInchargeData);
    setEditTransferStationInchargeId(selectedTransferStationInchargeData.id);
    setSelectedTransferStationIncharge(selectedTransferStationInchargeData);
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);

    setFormInput({
      ...formInput,

      transferStationInchargeName: selectedTransferStationInchargeData.transferStationInchargeName,
      associatedTransferStationIds:
        selectedTransferStationInchargeData.associatedTransferStationIds,
      emailId: selectedTransferStationInchargeData.emailId,
      isSupervisor: selectedTransferStationInchargeData.isSupervisor,
      mobileNumber: selectedTransferStationInchargeData.mobileNumber,
      isActive: selectedTransferStationInchargeData.isActive,
      transferStationInchargeId:
        selectedTransferStationInchargeData.transferStationInchargeId,
    });
    console.log(selectedTransferStationInchargeData, "assiociatedtransferstation")
    reset();
  };

  const fetchTransferStationIncharge = async () => {
    try {
      const allTransferStations = await getAllTransferStationMaster();
      const transferStationInchargeDataResponse =
        await getAllTransferStationInchargeMaster();

      const sortedInchargeData = transferStationInchargeDataResponse
        .map((transferStation) => {
          const associatedTransferStation = allTransferStations.find(
            (station) =>
              transferStation.associatedTransferStationIds.includes(
                station.transferStationId
              )
          );

          return {
            ...transferStation,
            associatedTransferStation: associatedTransferStation
              ? associatedTransferStation.transferStationName
              : "N/A",
            InchargeName: transferStation
              ? transferStation.transferStationInchargeName
              : "N/A",
            status: transferStation.isActive ? "Active" : "InActive",
          };
        })
        .sort((a, b) => {
          if (a.isActive === b.isActive) {
            return 0;
          }
          return a.isActive ? -1 : 1;
        });

      setTransferStationInchargeData(sortedInchargeData);
      setIsOptionsLoading(false);
      setOriginalData(sortedInchargeData);
      setFilterOriginalTSInchargeData(sortedInchargeData)
    } catch (error) {
      console.error(
        "Error fetching Deployment TransferStationIncharge data:",
        error
      );
    }
  };

  const fetchAssociatedTransferStation = async () => {
    try {
      const response = await GetAllAssociatedTransferStations();
      setAssociatedTransferStationData(response);
      // console.log(response, 'fetchAssociatedTransferStation')
      setIsOptionsLoading(false);

    } catch (error) {
      console.error(
        "Error fetching Deployment TransferStationIncharge data:",
        error
      );
    }
  };

  const addNewTransferStationIncharge = async (data) => {
    try {
      setFormSubmitted(true);
      const firstDigit = formInput.mobileNumber.charAt(0);
      if (
        !formInput.transferStationInchargeName ||
        !formInput.associatedTransferStationIds.length ||
        !formInput.emailId ||
        !formInput.mobileNumber
      ) {
      
        return;

      } else {
        setIsOptionsLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setIsOptionsLoading(false);
      }

      const {
        transferStationInchargeName,
        associatedTransferStationIds,
        emailId,
        transferStationInchargeId,
        mobileNumber,
        isSupervisor,
        isActive,
      } = formInput;
      const requestData = {
        transferStationInchargeName,
        associatedTransferStationIds: Array.isArray(
          associatedTransferStationIds
        )
          ? associatedTransferStationIds // If it's already an array, use it as is
          : associatedTransferStationIds.split(",").map(Number), // Otherwise, convert it to an array
        emailId,
        transferStationInchargeId,
        mobileNumber,
        isSupervisor,
        isActive,
      };
      if (selectedTransferStationIncharge) {
        const res = await updateTransferStationInchargeMaster(
          selectedTransferStationIncharge.id,
          requestData
        );
        const successMessage = "Transfer Station Incharge Updated Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchTransferStationIncharge();
        reset();
        handleClose();
      } else {
        const res = await createTransferStationInchargeMaster(requestData);
        // console.log(res, 'res from add')
        const successMessage =
          "Transfer Station Incharge Added Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchTransferStationIncharge();
        reset();
        handleClose();
      }
    } catch (error) {
      console.log(error.response, "error.response.status");
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(addNewTransferStationIncharge);
    }
  };

  useEffect(() => {
    fetchTransferStationIncharge();
    fetchAssociatedTransferStation();
  }, []);

  // const handleStatusChange = (e) => {
  //   const statusValue = e.target.id === "true" ? true : false;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     status: statusValue,
  //   }));
  // };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setFormInput({
      transferStationInchargeName: "",
      associatedTransferStationIds: "",
      emailId: "",
      isSupervisor: true,
      mobileNumber: "",
      isActive: true,
    });
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };

  const handleSupervisorChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  const handleAssociateChange = (selectedOptions) => {
    // If selectedOptions is an array, it means multiple options are selected
    // Otherwise, it's a single option
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.value)
      : selectedOptions
        ? selectedOptions.value
        : null;

    // Update the form input with the selected values
    setFormInput((prevState) => ({
      ...prevState,
      associatedTransferStationIds: selectedValues,
      // Automatically switch to true if more than one transfer station is selected
      isSupervisor:
        selectedValues && selectedValues.length > 1
          ? true
          : prevState.isSupervisor,
    }));
    if (selectedValues && selectedValues.length === 0 && formSubmitted) {
      setIsInputValid(false); // Set input validity to false if no options selected after form submission
    } else {
      setIsInputValid(true); // Set input validity to true if options are selected or form not submitted
    }
  };

  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...transferStationInchargeData].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = sortConfig ? sortedData : originalData; // Use sorted or original data
    downloadAsExcel(dataToExport); // Export the data
  };

  const options2 = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options2)
    .replace(/\//g, "/")}`;

    const downloadAsExcel = async () => {
      // Create a new workbook and add a worksheet
      const dataToUse = sortedData.length > 0 ? sortedData : originalData;
      const currentDate = new Date();
      const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
      const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
      const downloadDateTime = `Transfer Station Incharge Report Generated on: ${generationTime},${formattedTime}`;
      
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Transfer Station Incharge");
    
      // Define styles
      const boldFont = { bold: true };
    
      // Add the downloadDateTime to the correct row and columns, and ensure formatting
      worksheet.addRow(["", "", downloadDateTime, ""]);
      worksheet.mergeCells(1, 2, 1, 11);
      worksheet.getCell(1, 2).value = downloadDateTime;
      worksheet.getCell(1, 2).font = boldFont;
      worksheet.getCell(1, 2).alignment = { horizontal: "center" };
    
      // Add "Zone Details" row
      worksheet.addRow(["", "", "Transfer Station Incharge", ""]);
      worksheet.mergeCells(2, 2, 2, 11);
      worksheet.getCell(2, 2).value = "Transfer Station Incharge";
      worksheet.getCell(2, 2).font = boldFont;
      worksheet.getCell(2, 2).alignment = { horizontal: "center" };
    
      // Add the table header row
      const tableHeaderRow = worksheet.addRow([
        "S.No",
        "Incharge Name",
        "Associated Transfer Station",
        "Email ID",
        "Is Supervisor",
        "Mobile Number",
        "Status"
      ]);
    
      tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" };
        if (colNumber >= 1 && colNumber <= 7) {
          // Apply background color to header
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F6B1B1" }, // Red background color
          };
        }
      });
    
      // Add data rows
      dataToUse.forEach((item, index) => {
        // Map the associatedTransferStationIds to their names
        const stationNames = item.associatedTransferStationIds
          .map(id => {
            const station = associatedTransferStationData.find(station => station.transferStationId === id);
            return station ? station.transferStationName : "N/A";
          })
          .join(", "); // Join names with commas
          const supervisorStatus = item.isSupervisor ? "true" : "false";
    
        worksheet.addRow([
          index + 1,
          item.transferStationInchargeName || 'N/A',
          stationNames || 'N/A', // Ensure stationNames variable handles "N/A" if empty
          item.emailId || 'N/A',
          supervisorStatus || 'N/A', // Ensure supervisorStatus variable handles "N/A" if empty
          item.mobileNumber || 'N/A',
          item.status || 'N/A'
        ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 7) {
            cell.alignment = { horizontal: "left" }; // Left-align columns
          }
        });
      });
    
      // Set column widths dynamically based on content
      worksheet.columns = [
        { width: 5 },
        { width: 25 },
        { width: 45 },
        { width: 25 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
      ];
    
      // Save the workbook to a file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "TransferStationIncharge.xlsx";
      a.click();
      URL.revokeObjectURL(url);
    };
    

  const options = associatedTransferStationData.filter((station)=>station.isActive).map((station) => ({
    value: station.transferStationId,
    label: station.transferStationName,
  }));
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let sanitizedValue = value; // Initialize sanitized value with the input value

    if (name === "mobileNumber") {
      // Remove any non-numeric characters
      sanitizedValue = value.replace(/\D/g, '');
    
      // Check if the first digit is 0-5 and clear the value if invalid
      if (/^[0-5]/.test(sanitizedValue)) {
        sanitizedValue = "";
      } else {
        // Limit to 10 digits
        sanitizedValue = sanitizedValue.slice(0, 10);
      }
    }
    
    // Update the state based on the field name
    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));

    if (name === "mobileNumber") {
      const firstDigit = sanitizedValue.charAt(0);
      if (!["6", "7", "8", "9"].includes(firstDigit)) {
        // Show error message or handle invalid format
        // For now, I'm just logging an error message
        console.error("Mobile number must start with 6, 7, 8, or 9");

      }
    };
  }

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }

  const searchTransferStationInchargeHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalTSInchargeData.filter(item => item?.associatedTransferStation?.toLowerCase()?.includes(term) || item?.mobileNumber?.toLowerCase()?.includes(term))
    setTransferStationInchargeData(data);
  }
  const searchTransferStationInchargeNameHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalTSInchargeData.filter(item =>
      item?.transferStationInchargeName?.toLowerCase()?.includes(term) // Check if the name includes the search term
    );
    setTransferStationInchargeData(data); // Update the state with filtered data
  };
  
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <h4 class="text-start mb-3">{t("Transfer Station incharge")}</h4>
            <div className="row mt-3  align-items-center">
              <div className="col-md-3">
                <input
                  placeholder="Mobile Number & TransferStation Incharges"
                  type="text"
                  className="form-control bg-white"
                  onInput={searchTransferStationInchargeHandler}
                />
              </div>
              <div className="col-md-3">
                <input
                  placeholder="Search Transfer Station Incharge Name"
                  type="text"
                  className="form-control bg-white"
                  onInput={searchTransferStationInchargeNameHandler}
                />
             </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-end">
                  {canWriteValue === true ?
                    <button className="button-container" onClick={handleShow}>
                      <i className="fa-solid fa-plus me-1 icon-container"></i>
                      {t("Add TS Incharge")}
                    </button>
                    : ""}
                  <button
                    className="btn btn-excel"
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>
                </div>
              </div>
            </div>


            <div className="card mt-3">
              <div className="card-body">

                <TableComponent
                  DataFetchURL={transferStationInchargeData}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 0
                    )
                  }
                  editData={handleEditTransferStationIncharge}
                  editTransferStationInchargeData={
                    editTransferStationInchargeData
                  }
                  onSort={handleSort}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOptionsLoading && <Loader />}
      <Modal
        // centered
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {selectedTransferStationIncharge ? "Edit TransferStation Incharge" : "Add TransferStation Incharge"}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewTransferStationIncharge)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit);
            }}
          >
            <div className="row">
              {/* {selectedTransferStationIncharge ? ( */}
              <div className="col-md-4 " style={{ display: "none" }}>
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station incharge Id
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="transferStationInchargeId"
                    {...register("transferStationInchargeId")}
                    value={formInput.transferStationInchargeId}
                    readOnly
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        transferStationInchargeId: e.target.value,
                      })
                    }
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station incharge Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Incharge Name"
                    className={`form-control ${formInput.transferStationInchargeName || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    name="transferStationInchargeName"
                    {...register("transferStationInchargeName")}
                    value={formInput.transferStationInchargeName}
                    onChange={(e) =>{
                      let sanitizedValue = e.target.value
                      .slice(0, 42) // Limit to 42 characters
                      .replace(/[^A-Za-z ]/g, '')
                      .replace(/^\s+/, "") // Remove leading spaces
                      .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
                      setFormInput({
                        ...formInput,
                        transferStationInchargeName: sanitizedValue,
                      })
                    }}
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.transferStationInchargeName && formSubmitted && (
                    <div className="required-message">
                      Transfer Station incharge Name is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-8">
                <div className="form-group">
                  <label className="form-label">
                    Associated Transfer Station {" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <div className="select-container">
                    <Select
                      classNamePrefix="CreatableSelect"
                      className={`select-component ${(!formInput.associatedTransferStationIds.length && formSubmitted) ? "input-error" : ""}`}
                      id="associatedTransferStationIds"
                      name="associatedTransferStationIds"
                      value={options.filter((option) => formInput.associatedTransferStationIds.includes(option.value))}
                      onChange={handleAssociateChange}
                      isMulti
                      options={options}
                      disabled={!canWriteValue}
                    />
                  </div>
                  {formSubmitted && !formInput.associatedTransferStationIds.length && (
                    <div className="required-message">
                      Associated Transfer Station is Required
                    </div>
                  )}
                </div>
              </div>



              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Email ID<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter Email ID"
                    className={`form-control ${formInput.emailId || !formSubmitted ? "" : "input-error"
                      }`}
                    name="emailId"
                    {...register("emailId")}
                    value={formInput.emailId}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        emailId: e.target.value,
                      })
                    }
                    maxLength={42}
                    disabled={!canWriteValue}
                  />
                  {!formInput.emailId && formSubmitted && (
                    <div className="required-message">Email ID is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Mobile Number<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    //  type="number"
                    placeholder="Enter Mobile Number"
                    className={`form-control ${formInput.mobileNumber || !formSubmitted
                      ? ""
                      : "input-error"
                      }`}
                    name="mobileNumber"
                    {...register("mobileNumber")}
                    value={formInput.mobileNumber}
                    onChange={handleInputChange}
                    pattern="[0-9]{10}" // Specify the pattern for 10 digits
                    title="Mobile number must be 10 digits"
                    disabled={!canWriteValue}
                  />
                  {formInput.mobileNumber.length !== 10 && formSubmitted && (
                    <div className="required-message">
                     Mobile number must be 10 digits
                    </div>
                  )}
                  {/* {!formInput.mobileNumber && formSubmitted && (
                    <div className="required-message">
                      Mobile Number is Required
                    </div>
                  )} */}
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label">
                  Supervisor<span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isSupervisor"
                      id="supervisorActiveRadio"
                      {...register("isSupervisor")}
                      value="true"
                      checked={formInput.isSupervisor === true}
                      onChange={handleSupervisorChange}
                      disabled={!canWriteValue}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="supervisorActiveRadio"
                    >
                      True
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isSupervisor"
                      id="supervisorInactiveRadio"
                      {...register("isSupervisor")}
                      value="false"
                      checked={formInput.isSupervisor === false}
                      onChange={handleSupervisorChange}
                      disabled={
                        formInput.associatedTransferStationIds &&
                        formInput.associatedTransferStationIds.length > 1
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="supervisorInactiveRadio"
                    >
                      False
                    </label>
                  </div>
                </div>
              </div>
              {/* {selectedContainer ? ( */}
              <div className="col-md-4">
                <label className="form-label">
                  Status <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      {...register("isActive")}
                      value="true"
                      checked={formInput.isActive === true}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "true" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      {...register("isActive")}
                      value="false"
                      checked={formInput.isActive === false}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "false" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>

              {/* ) : (
                ""
              )} */}
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {selectedTransferStationIncharge ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(TransferStationInchargeMaster);

